"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("components");
const VerifyStoreInfoHeader = () => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(components_1.H1, { children: ["Let's make sure this looks accurate. ", (0, jsx_runtime_1.jsx)("br", { className: "desk-only" }), "Verify your Practice Information"] }), (0, jsx_runtime_1.jsx)(components_1.H2, { variant: "title-extra-large", className: "verify-store-information-subtitle", children: "Please review your practice information and make any necessary revisions. Once you're all set, accept the updated terms and submit." })] }));
};
exports.default = VerifyStoreInfoHeader;
